// extracted by mini-css-extract-plugin
module.exports = {"section":"index-module--section--T685Y","papers":"index-module--papers--1lULl"};